// extracted by mini-css-extract-plugin
module.exports = {"articleItem__inner":"ArticleItem_articleItem__inner__mntO5","articleItem":"ArticleItem_articleItem__C_SWr"};